import { computed }                                                   from '@vue/composition-api';
import { GlobalContexts, useGlobals }                                 from '@/hooks/use-globals';
import { Computed }                                                   from '@/types';
import { State }                                                      from '@/views/group-quotation-list/store/state.store';
import { GroupQuote }                                                 from '@/views/group-quotation-list/group-quotation-list.types';
import { name as GroupQuotation, nameModeEdit as GroupQuotationEdit } from '@/views/group-quotation/group-quotation.route';

interface UseGroupQuotationList {
  tableColumns: string[];
  tableData: Computed<GroupQuote[]>;
  loading: Computed<boolean>;
  getLocalTranslation: (path: string) => string;
  onEditAction: (row: GroupQuote) => void;
  goToGroupQuotationEditView: (row?: GroupQuote) => void;
}

export const useGroupQuotationList = (): UseGroupQuotationList => {
  const { i18n, store, router }: GlobalContexts = useGlobals();

  const getLocalTranslation = (path: string): string => i18n.t(`vGroupQuotationList.${path}`)
    .toString();

  const tableData: Computed<GroupQuote[]> = computed(() => (store.state.views.vGroupQuotationList as State).quotes);
  const loading: Computed<boolean> = computed(() => (store.state.views.vGroupQuotationList as State).loading);
  const tableColumns: string[] = [
    'groupName',
    'groupCode',
    'groupCodeLabel',
    'market',
    'user',
    'creationDate',
    'arrivalDate',
    'departureDate',
    'lengthOfStay',
    'followUp',
    'materializationStatus',
    'actions',
  ];

  const goToGroupQuotationEditView = (row?: GroupQuote) => {
    router.push({
      name: row ? GroupQuotationEdit : GroupQuotation,
      params: {
        quotationUuid: row ? row.uuid : '',
      },
    });
  };

  const onEditAction = (row: GroupQuote): void => {
    goToGroupQuotationEditView(row);
  };

  return {
    tableColumns,
    tableData,
    loading,
    getLocalTranslation,
    goToGroupQuotationEditView,
    onEditAction,
  };
};
